<div class="d-flex flex-column overflow-hidden h-100 pt-2 px-5">
  <nav
    mat-tab-nav-bar
    class="tab-header-bottom-border tab-header-round-top py-2"
    mat-stretch-tabs="false"
    [tabPanel]="tabPanel"
  >
    @for (tab of dashboardTabs; track tab) { @if(tab.isVisible){
    <a
      mat-tab-link
      id="tab.htmlId"
      class="tab-header-round-top"
      [routerLink]="tab.routerLink"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla.isActive"
      disableRipple
    >
      {{ tab.title }} {{ tab.labelCount }}
      @if(tab.htmlId === 'tab-referrals' && hasReferralsAwaitingAcknowledgement)
      {
      <mat-icon
        id="referral-needs-acknowledgement"
        class="small-icon ml-2"
        svgIcon="filled-warning-triangle"
      ></mat-icon>
      }
    </a>
    } }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
